/** Shown when no route provides a description. */
export const DEFAULT_META_DESCRIPTION =
  'Akalan helps India job seekers practice AI voice mock interviews, scan resumes with an ATS checker, and rewrite bullets for any job description in English or Hindi. Start free, no card required.';

/** Open Graph default description. */
export const DEFAULT_OG_DESCRIPTION =
  'Practice AI mock interviews that push back like real interviewers. Get STAR feedback, ATS resume scoring, and JD-tailored rewrites before your next round.';

/** Twitter default description. */
export const DEFAULT_TWITTER_DESCRIPTION =
  'Stop winging interviews. Akalan gives you voice mock practice, ATS resume checks, and instant feedback in English or Hindi. Start free today.';

/** Primary keyword targets for India job prep + AI search (AEO). */
export const DEFAULT_KEYWORDS =
  'AI mock interview India, mock interview platform India, voice interview practice, interview preparation freshers India, SDE mock interview, behavioral interview practice, ATS resume checker India, resume rewrite job description, Hindi mock interview, AI interview coach, technical interview practice, HR interview prep, Akalan AI, free mock interview online, interview simulator India';

export const HOME_KEYWORDS = DEFAULT_KEYWORDS;

export const CONTACT_KEYWORDS =
  'Contact Akalan, Akalan support email, hello@akalan.in, Akalan college partnership, Akalan company demo, book Akalan demo';

export const ABOUT_KEYWORDS =
  'About Akalan, Akalan AI company, AI interview prep India, mock interview platform India, Koderscare Technologies, voice interview practice India';

export const PORTFOLIO_KEYWORDS =
  'online portfolio builder India, resume to portfolio page, shareable portfolio link, personal portfolio for job seekers, Akalan portfolio';

export const JOB_SEARCH_KEYWORDS =
  'Resume Rewrite Akalan, JD tailored resume rewrite India, rewrite resume for job description, ATS resume rewrite, job description resume rewrite';

export const INTERVIEW_KEYWORDS =
  'AI mock interview India, voice interview practice, mock interview platform India, STAR interview feedback, Akalan mock interview';

export const SITE_NAME = 'Akalan AI';

/** Default document title — primary keyword in first segment. */
export const DEFAULT_DOCUMENT_TITLE =
  'AI Mock Interview Practice India | Voice Interviews & ATS Resume Check';

export const TWITTER_CARD = 'summary_large_image';

export const TWITTER_SITE = '@akalanai';

export const TWITTER_CREATOR = '@akalanai';

/** `robots.googleBot` → single directive string for `<meta name="googlebot">`. */
export const DEFAULT_GOOGLEBOT =
  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

/** Path under `appUrl` for default OG / Twitter image. */
export const DEFAULT_OG_IMAGE_PATH = '/akalan-lockup.png';

export const DEFAULT_OG_IMAGE_WIDTH = '1200';

export const DEFAULT_OG_IMAGE_HEIGHT = '630';

export const DEFAULT_OG_IMAGE_ALT =
  'Akalan AI: AI mock interview and ATS resume prep for India job seekers';
